import React from 'react';
import styled from 'styled-components';
import { Spring, animated } from 'react-spring';

import { upTo } from 'js/services/MediaQuery';
import Constraint from 'js/components/Constraint';
import AppContent from '../AppContent';
import Icon from 'js/components/common/Icon';

import { startAnimation, endAnimation } from 'js/config/style';

const Message = styled.div`
  margin-top: 1rem;
  font-weight: 500;
  padding: 1rem;
`;

const Container = animated(styled.div`
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.16);
  border-top: 1px solid #eaedf2;
  width: 430px;
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
  background: white;
  position: relative;

  ${upTo('sm')`
    width: 100%;
    padding: 1rem 0;
    box-shadow: none;
    border-top: none;
  `};
`);

const AlertIcon = styled(Icon).attrs({ name: 'exclamation-circle' })`
  font-size: 3rem;
  color: #555;
  margin-bottom: 1rem;
`;

export default () => (
  <AppContent padded>
    <Constraint>
      <Spring native from={startAnimation} to={endAnimation}>
        {animation => (
          <Container style={animation}>
            <Message>
              <AlertIcon />
              <p>Something went wrong.</p>
              <p>Please reload to try again.</p>
            </Message>
          </Container>
        )}
      </Spring>
    </Constraint>
  </AppContent>
);
